import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
function PulsingDot(t0) {
  const $ = _c(16);
  const {
    dotClassName,
    waveClassName
  } = t0;
  let t1;
  if ($[0] !== waveClassName) {
    t1 = cn("absolute size-4 rounded-full motion-reduce:hidden", waveClassName, "animate-pulse-ring");
    $[0] = waveClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span aria-hidden={true} className={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== waveClassName) {
    t3 = cn("absolute size-4 rounded-full motion-reduce:hidden", waveClassName, "animate-pulse-ring [animation-delay:1s]");
    $[4] = waveClassName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <span aria-hidden={true} className={t3} />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== dotClassName) {
    t5 = cn("relative size-4 rounded-full", dotClassName);
    $[8] = dotClassName;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <span className={t5} />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t4 || $[14] !== t6) {
    t7 = <div className="relative flex size-4 items-center justify-center">{t2}{t4}{t6}</div>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
export { PulsingDot };